export default {'version' : '3.0-19-gee19679'};
